import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { Select } from "components"
import { withRadium } from "higher-order-components"

class SelectSectionMapLocationContainer extends PureComponent {
  render() {
    return (
      <div>
        {!this.props.dropDownDisabled && (
          <div style={styles.dropDown}>
            <Select
              onChange={value => this.props.handleSelectDropDown(value, false)}
              label={this.props.dropDownLabel}
              active={this.props.activeIndexOfStates}
              options={this.props.uniqStates || []} />
          </div>
        )}
      </div>
    )
  }
}

SelectSectionMapLocationContainer.propTypes = {
  dropDownDisabled: PropTypes.bool,
  handleSelectDropDown: PropTypes.func,
  activeIndexOfStates: PropTypes.number,
  uniqStates: PropTypes.array,
  dropDownLabel: PropTypes.string
}

const styles = {
  dropDown: {
    width: "80%",
    margin: "1.8em auto",
    boxSizing: "border-box",
    maxWidth: "15em"
  }
}

export default withRadium()(SelectSectionMapLocationContainer)



// WEBPACK FOOTER //
// ./src/containers/map-location/select-section.jsx